import clsx from '../lib/clsx';
import type { ReactNode } from 'react';

export function Pill({ tone = 'muted', children, icon }: { tone?: 'ok' | 'warn' | 'error' | 'info' | 'muted'; children: ReactNode; icon?: ReactNode }) {
  const cls = {
    ok: 'pill-ok',
    warn: 'pill-warn',
    error: 'pill-error',
    info: 'pill-info',
    muted: 'pill-muted',
  }[tone];
  return (
    <span className={clsx('pill', cls)}>
      {icon}
      {children}
    </span>
  );
}

export function Stat({ label, value, sub, tone }: { label: string; value: ReactNode; sub?: ReactNode; tone?: 'ok' | 'warn' | 'error' }) {
  return (
    <div className="card p-5">
      <div className="label">{label}</div>
      <div className={clsx('text-2xl font-bold tracking-tight',
        tone === 'ok' && 'text-ok',
        tone === 'warn' && 'text-warn',
        tone === 'error' && 'text-danger',
      )}>{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-400">{sub}</div>}
    </div>
  );
}

export function ProgressBar({ pct, tone }: { pct: number; tone?: 'ok' | 'warn' | 'error' }) {
  const safe = Math.max(0, Math.min(100, pct));
  const color = tone === 'ok' ? 'bg-ok' : tone === 'warn' ? 'bg-warn' : tone === 'error' ? 'bg-danger' : 'bg-accent';
  return (
    <div className="h-2 rounded-full bg-bg-subtle overflow-hidden">
      <div className={clsx('h-full transition-all', color)} style={{ width: `${safe}%` }} />
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="card p-10 text-center">
      <div className="text-lg text-slate-300">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1">{hint}</div>}
      {action && <div className="mt-4 inline-flex">{action}</div>}
    </div>
  );
}

export function Spinner() {
  return (
    <div className="grid place-items-center h-40 text-slate-400 animate-pulseSoft">Carregando…</div>
  );
}
